import React from 'react';
import DOM from 'react-dom';

export default function resizeListener(WrappedComponent) {
    return class ResizeListener extends React.Component {
        componentDidMount() {
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }

        state = {};

        handleResize = () => {
            const size = DOM.findDOMNode(this).getBoundingClientRect();
            this.setState({ width: size.width });
        };

        render() {
            return <WrappedComponent {...this.props} {...this.state} />;
        }
    };
}
